import { BookmarkBorderOutlined, BookmarkOutlined } from "@mui/icons-material";
import { Box, IconButton, SxProps } from "@mui/material";
import { useAppSelector } from "../../Redux/store";
import { skipToken } from "@reduxjs/toolkit/query";
import { useBookmarkJobMutation, useGetTalentQuery, useUnbookmarkJobMutation } from "../../Redux/api/talentApi";
import { useBookmarkTalentMutation, useGetClientQuery, useUnbookmarkTalentMutation } from "../../Redux/api/clientApi";
import { useMemo } from "react";
import { useToast } from "../../Hooks/useToast";

interface KaziBookmarkProps {
    locator: string;
    sx?: SxProps;
    bookmarkSx?: SxProps;
}

export const KaziBookmark = ({ locator, sx, bookmarkSx}: KaziBookmarkProps) => {
    /* ******************** Hooks ******************** */
    const { showToast } = useToast();
    const globalSlice = useAppSelector( state => state.Global)
    const { talentBookmarks } = useGetTalentQuery(((globalSlice.userType === "talent" ? globalSlice.userId : undefined )|| skipToken), {
        selectFromResult: ({ data }) => ({
            talentBookmarks: data?.bookmarked_jobs,
        })
    })
    const { clientBookmarks } = useGetClientQuery(((globalSlice.userType === "client" ? globalSlice.userId : undefined )|| skipToken), {
        selectFromResult: ({ data }) => ({
            clientBookmarks: data?.bookmarked_talents,
        })
    })
    const [bookmarkTalent, {data: bookmarkTalentResponse}] = useBookmarkTalentMutation();
    const [bookmarkJob, {data: bookmarkJobResponse}] = useBookmarkJobMutation();
    const [unbookmarkTalent, {data: unbookmarkTalentResponse}] = useUnbookmarkTalentMutation();
    const [unbookmarkJob, {data: unbookmarkJobResponse}] = useUnbookmarkJobMutation();
    /* ******************** Variables ******************** */
    const isBookmarked = useMemo(() => {
        if (talentBookmarks?.some( bk => bk === locator)) return true;
        if (clientBookmarks?.some( bk => bk === locator)) return true;
        return false
    }, [talentBookmarks, clientBookmarks])
    const style = {
        margin: 0, 
        alignSelf: 'center',
        color: 'primary.main',
        ...bookmarkSx
    }
    /* ******************** Functions ******************** */
    const handleClick = () =>{
        switch(globalSlice.userType) {
            case 'talent':
                if (!isBookmarked) {
                    bookmarkJob({
                        locator: globalSlice.userId!,
                        bookmarks: [locator]
                    })
                    .unwrap()
                    .then( res => console.log(res))
                    .catch( err => {
                        console.log(err);
                        showToast({
                            text: 'Unable to bookmark Job'
                        })
                    })
                }
                if (isBookmarked) {
                    unbookmarkJob({
                        locator: globalSlice.userId!,
                        bookmarks: [locator]
                    })
                    .unwrap()
                    .then( res => console.log(res))
                    .catch( err => {
                        console.log(err);
                        showToast({
                            text: 'Unable to remove bookmark',
                            variant: 'error'
                        })
                    })
                }
                break; 
            case 'client':
                if (!isBookmarked) {
                    bookmarkTalent({
                        locator: globalSlice.userId!,
                        bookmarks: [locator]
                    })
                    .unwrap()
                    .then( res => console.log(res))
                    .catch( err => {
                        console.log(err);
                        showToast({
                            text: 'Unable to bookmark Talent'
                        })
                    })
                }
                if (isBookmarked) {
                    unbookmarkTalent({
                        locator: globalSlice.userId!,
                        bookmarks: [locator]
                    })
                    .unwrap()
                    .then( res => console.log(res))
                    .catch( err => {
                        console.log(err);
                        showToast({
                            text: 'Unable to remove bookmark',
                            variant: 'error'
                        })
                    })
                }
                break;
        }
    }
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <>
                <IconButton onClick={handleClick} size='small' disabled={!globalSlice.userId} sx={{...sx}}>
                    {
                        isBookmarked ?                
                        <BookmarkOutlined fontSize="large" sx={{...style}} /> :
                        <BookmarkBorderOutlined fontSize="large" sx={{...style}} />
                    }
                </IconButton>
        </>
    )
}